import { ActionReducer } from '@ngrx/store';

import { LocalStorageService } from '../../features/shared/services/local-storage.service';
import { RootState } from '../root-state.model';
import { RootStoreActions } from '../root-store.actions';

export function localStorageSyncFactory() {
  return (reducer: ActionReducer<RootState>): ActionReducer<RootState> => {
    return (state, action) => {
      if (action?.type === RootStoreActions.LoadFromLocalStorage.type) {
        const { email, displayName } = action as RootStoreActions.LoadFromLocalStorageType;
        LocalStorageService.set(email, 'user-email');
        LocalStorageService.set(displayName, 'user-display-name');
      }

      return reducer(state, action);
    };
  };
}
